import React, { useState } from 'react'
import {
  Flex,
  Box,
  Text,
  Center,
  useColorMode,
  chakra,
  useDisclosure,
} from '@chakra-ui/react'

import LEColorConstants, {
  lightBgStep,
  lightBgTheme,
} from '@/lib/constants/colorConstants'
import {
  partnerQuestionDescription,
  partnerThreeSteps,
  partnerThreeStepTitle,
  partnerFourStepTitle,
  partnerFourStepDescription,
  partnerFourSteps,
} from '@/lib/constants/partner'
import CustomButton from '@/components/Button'
import HelpModal from '@/components/Help/HelpModal'

function Steps() {
  const { colorMode } = useColorMode()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [becomePartner, setBecomePartner] = useState<boolean>(false)

  const handleBecomePartner = () => {
    setBecomePartner(true)
    onOpen()
  }
  return (
    <chakra.section>
      <Flex
        flexDir={'column'}
        mx="auto"
        py="6rem"
        overflow="hidden"
        maxW="90rem"
        px={['1rem', '3rem', '4rem', '6rem']}
      >
        <Flex
          width={'full'}
          columnGap={'4rem'}
          rowGap="4.4rem"
          flexDirection={['column', 'row', 'row', 'row']}
          mx="auto"
          pb="6rem"
          justifyContent={'space-between'}
          mb="5rem"
        >
          {partnerQuestionDescription &&
            partnerQuestionDescription.length > 0 &&
            partnerQuestionDescription.map(item => (
              <Box
                key={item.id}
                justifyContent={'center'}
                alignItems="left"
                w="full"
                p="1.5rem"
                pb="3rem"
                border={`2px solid ${LEColorConstants.primary}`}
                borderRadius="5px"
                role="group"
                _hover={{
                  backgroundColor: LEColorConstants.primary,
                  transition: 'all .5s ease-in-out',
                  borderRadius: '5px',
                }}
                textAlign={'left'}
                lineHeight={['25px', '33px']}
              >
                <Text
                  fontSize={{ base: '1.1rem', md: '1.37rem' }}
                  fontWeight={500}
                  _groupHover={{
                    color: LEColorConstants.white,
                  }}
                  textAlign="left"
                  mb={['1rem', '1.5rem']}
                >
                  {item.title}
                </Text>
                <Text
                  fontSize={{ base: '1rem', md: '1.1rem' }}
                  fontWeight={400}
                  _groupHover={{
                    color: LEColorConstants.white,
                  }}
                >
                  {item.description}
                </Text>
              </Box>
            ))}
        </Flex>

        <Flex flexDir={'column'} mb="3rem">
          <Text
            fontSize={['1.2rem', '1.5rem']}
            fontWeight="600"
            lineHeight={'45px'}
            mb="3rem"
          >
            {partnerThreeStepTitle}
          </Text>
          <Flex gap="1rem" justifyContent={'space-between'} flexWrap="wrap">
            {partnerThreeSteps &&
              partnerThreeSteps.length > 0 &&
              partnerThreeSteps.map((item, i) => (
                <Center
                  key={`partners_${i}`}
                  w={['10rem', '13rem', '13rem', '15rem']}
                  h={['10rem', '13rem', '13rem', '15rem']}
                  background={lightBgTheme[colorMode]}
                  borderRadius="50%"
                  overflow={'hidden'}
                  p="1rem"
                  mx={{ base: 'auto', md: '0' }}
                >
                  <Box textAlign={'center'}>
                    <Text
                      fontSize={['0.8rem', '1.2rem']}
                      fontWeight="600"
                      lineHeight={'33px'}
                      as="p"
                      mb="1rem"
                    >
                      {item.title}
                    </Text>
                    <Text
                      as="p"
                      fontSize={['0.6rem', '1rem']}
                      fontWeight="400"
                      lineHeight={['13px', '24px']}
                    >
                      {item.description}
                    </Text>
                  </Box>
                </Center>
              ))}
          </Flex>
        </Flex>
      </Flex>

      <Flex flexDir={'column'} w="full" bg={lightBgStep[colorMode]}>
        <Flex
          mx="auto"
          py="6rem"
          overflow="hidden"
          maxW="90rem"
          px={['1rem', '3rem', '4rem', '6rem']}
          flexDir={'column'}
        >
          <Flex w="full" flexDirection={'column'} mb="5rem">
            <Text
              textAlign={'left'}
              fontSize={{ base: '1.2rem', md: '2rem' }}
              lineHeight={'50px'}
              fontWeight="600"
              color={LEColorConstants.primary}
              mb="1.2rem"
            >
              {partnerFourStepTitle}
            </Text>
            <Text
              maxW="44rem"
              fontSize={{ base: '1rem', md: '1.2rem' }}
              lineHeight="33px"
              mb="1.2rem"
            >
              {partnerFourStepDescription}
            </Text>

            <Flex
              w="full"
              gap="1.6rem"
              justifyContent={'space-between'}
              flexWrap="wrap"
            >
              {partnerFourSteps &&
                partnerFourSteps.length > 0 &&
                partnerFourSteps.map((item, i) => (
                  <Box key={`partnerFourSteps_${i}`}>
                    <Text
                      fontSize={{ base: '1.5rem', md: '3rem' }}
                      lineHeight={['50px', '96px']}
                      fontWeight={'600'}
                    >
                      {item.title}
                    </Text>
                    <Text
                      maxW="15rem"
                      fontSize={{ base: '1rem', md: '1.25rem' }}
                      lineHeight={['20px', '30px']}
                    >
                      {item.description}
                    </Text>
                  </Box>
                ))}
            </Flex>
          </Flex>
        </Flex>
      </Flex>

      <Flex flexDir={'column'} w="full" bg={lightBgTheme[colorMode]}>
        <Flex
          mx="auto"
          py="6rem"
          overflow="hidden"
          maxW="90rem"
          px={['1.5rem', '3rem', '4rem', '6rem']}
        >
          <Flex
            justifyContent={'space-between'}
            alignItems={'center'}
            columnGap="6rem"
            rowGap={'2rem'}
            w="full"
            flexDirection={['column', 'row', 'row', 'row']}
          >
            <Text
              maxW={'full'}
              fontSize={['1.1rem', '1.4rem']}
              fontWeight={'500'}
              lineHeight="36px"
              textAlign={['center', 'left', 'left', 'left']}
            >
              Then becoming a TestNotion partner could be a great way to make
              money online.
            </Text>
            <CustomButton
              fontSize={['1rem', '1.3rem']}
              fontWeight="medium"
              maxW={{ base: '15rem', md: '25rem' }}
              variant="outline"
              p={{ base: '3rem 5rem', md: '4.5rem 6rem' }}
              borderRadius={'100px'}
              color="black"
              backgroundColor={'transparent'}
              onClick={handleBecomePartner}
            >
              Create Account
            </CustomButton>
            {becomePartner && (
              <HelpModal
                isOpen={isOpen}
                onClose={onClose}
                partnerAllow={true}
                onClick={onClose}
              />
            )}
          </Flex>
        </Flex>
      </Flex>
    </chakra.section>
  )
}

export default Steps
